module.exports = __webpack_public_path__ + "media/svg/bq-a7fdb74e.svg";